// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container-pojedini {
  width: 100%;
  height: 175px;
  border-radius: 4px;
  background: #ebe6dd;
  z-index: -1;
}

.pojedini-image {
  width: 230px;
  height: 175px;
  border-radius: 8px;
  border: 4px solid #fff;
  margin-left: 40px;
  transform: translateY(40px);
}

.edit-mode-opis {
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  background: #fff;
  height: auto;
  width: 450px;
  padding: 15px 16px;
  min-height: 120px;
  font-family: "Inter";
  color: #5f6d7e;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  resize: none;
}

textarea.custom-textarea {
  resize: none;
  border: none;
  outline: none;
}

.edit-mode-text {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}

.introspekcije-edit-div {
  border-radius: 8px;
  border: none;
  background: #cb9c2d;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  padding: 10px 16px;
  margin-top: 30px;
  margin-left: 8px;
  width: 350px;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.iskustveni-dio-edit-mode {
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  background: #fff;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  padding: 8px 16px;
  margin-left: 8px;
  width: 550px;
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}

.edit-mode-submoduls {
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  background: #fff;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  padding: 8px 16px;
  margin-left: 8px;
  width: 475px;
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}

.pojedini-program-save {
  width: 212px;
  height: 52px;
  padding: 8px 16px;
  border-radius: 4px;
  background: #cb9c2d;
  border: none;
  color: #fff;
  text-align: center;

  /* Label/Medium */
  font-family: "Inter";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.016px;
  cursor: pointer;
}

.pojedini-program-quit {
  border-radius: 4px;
  background: #ebebeb;
  width: 212px;
  height: 52px;
  padding: 8px 16px;
  color: #808080;
  text-align: center;

  /* Text M/Semi Bold */
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.015px;
  border: none;
  margin-right: 16px;
  cursor: pointer;
}

.pregled-programa {
  margin-top: 20px;
}

.text-navigate {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.015px;
}

@media screen and (max-width: 770px) {
  .btn-container {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    width: 82%;
    max-width: 400px;
  }
}

@media screen and (max-width: 600px) {
  .pojedini-image {
    width: 200px;
    height: 150px;
    transform: translateY(60px);
  }
}

@media screen and (max-width: 535px) {
  .edit-mode-opis {
    width: 100%;
  }
}

@media screen and (max-width: 425px) {
  .pojedini-image {
    margin-left: 20px;
  }
  .introspekcije-edit-div {
    width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/pojediniProgrami/ProgramContainer/ProgramContainer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;;EAElB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".image-container-pojedini {\n  width: 100%;\n  height: 175px;\n  border-radius: 4px;\n  background: #ebe6dd;\n  z-index: -1;\n}\n\n.pojedini-image {\n  width: 230px;\n  height: 175px;\n  border-radius: 8px;\n  border: 4px solid #fff;\n  margin-left: 40px;\n  transform: translateY(40px);\n}\n\n.edit-mode-opis {\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  background: #fff;\n  height: auto;\n  width: 450px;\n  padding: 15px 16px;\n  min-height: 120px;\n  font-family: \"Inter\";\n  color: #5f6d7e;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n  resize: none;\n}\n\ntextarea.custom-textarea {\n  resize: none;\n  border: none;\n  outline: none;\n}\n\n.edit-mode-text {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n\n.introspekcije-edit-div {\n  border-radius: 8px;\n  border: none;\n  background: #cb9c2d;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  padding: 10px 16px;\n  margin-top: 30px;\n  margin-left: 8px;\n  width: 350px;\n  color: #fff;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.iskustveni-dio-edit-mode {\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  background: #fff;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  padding: 8px 16px;\n  margin-left: 8px;\n  width: 550px;\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n\n.edit-mode-submoduls {\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  background: #fff;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  padding: 8px 16px;\n  margin-left: 8px;\n  width: 475px;\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n\n.pojedini-program-save {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  background: #cb9c2d;\n  border: none;\n  color: #fff;\n  text-align: center;\n\n  /* Label/Medium */\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 137.5% */\n  letter-spacing: -0.016px;\n  cursor: pointer;\n}\n\n.pojedini-program-quit {\n  border-radius: 4px;\n  background: #ebebeb;\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px;\n  color: #808080;\n  text-align: center;\n\n  /* Text M/Semi Bold */\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px; /* 146.667% */\n  letter-spacing: -0.015px;\n  border: none;\n  margin-right: 16px;\n  cursor: pointer;\n}\n\n.pregled-programa {\n  margin-top: 20px;\n}\n\n.text-navigate {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.015px;\n}\n\n@media screen and (max-width: 770px) {\n  .btn-container {\n    position: fixed;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: space-between;\n    width: 82%;\n    max-width: 400px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .pojedini-image {\n    width: 200px;\n    height: 150px;\n    transform: translateY(60px);\n  }\n}\n\n@media screen and (max-width: 535px) {\n  .edit-mode-opis {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 425px) {\n  .pojedini-image {\n    margin-left: 20px;\n  }\n  .introspekcije-edit-div {\n    width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
